/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

// Convert a raw Capacitor Device `batteryLevel` (a 0..1 fraction) into a
// whole percentage for publishing in presence. iOS reports -1 when
// battery monitoring isn't active yet, so any value outside 0..1 (or
// non-finite) is not a real reading and resolves to `undefined` — the
// caller leaves the presence field unset and viewers render the
// "Not shared yet" placeholder instead of a garbage value like -100%.
export function batteryPctFromLevel(
  level: number | undefined | null,
): number | undefined {
  if (typeof level !== "number" || !Number.isFinite(level)) return undefined;
  if (level < 0 || level > 1) return undefined;
  return Math.round(level * 100);
}
